// extracted by mini-css-extract-plugin
export var abtaLogo = "FooterCDCDisclaimer-module--abta-logo--95684";
export var cdcDisclaimerContainer = "FooterCDCDisclaimer-module--cdc-disclaimer-container--fb334";